import * as React from "react";
import { InputOptionalInfo, FormikFormGroup } from "components/common";
const TitleFormGroup = ({ wrapperClassName = void 0, labelClassName = void 0 }) => /* @__PURE__ */ React.createElement(
  FormikFormGroup,
  {
    name: "title",
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, "Title ", /* @__PURE__ */ React.createElement(InputOptionalInfo, null)),
    labelClassName,
    wrapperClassName,
    help: "Summarize the purpose of this filter."
  }
);
export default TitleFormGroup;
